export default __webpack_public_path__ + "static/media/Wireframes_Mobile-Portrait.56a29141.png";